const API_VER = 'v1.0'
export const TimecardEndpoints = {
  REPORT_TEMPLATE: `/att/report/api/${API_VER}/template/`,
  REPORT_TEMPLATE_LIST: `/att/report/api/${API_VER}/template/get_template_list/`,
}

